import { render } from "./CountByOrganization.vue?vue&type=template&id=6b7c4ef2"
import script from "./CountByOrganization.vue?vue&type=script&lang=js"
export * from "./CountByOrganization.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__